import axios, { AxiosError, AxiosResponse } from "axios";
import { eraseCookie, getCookie } from "../utils/utils";
import { message } from "antd";

const $axios = axios.create({
  baseURL: "https://1412api.bionet.az/api/",
  // baseURL: "http://localhost:8000/api/",
});

$axios.interceptors.request.use(
  async (config) => {
    const token = getCookie("BscAdminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

$axios.interceptors.response.use(
  async (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

$axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError<{ message?: string }>) => {
    const status = error.response?.status || 500;
    if (status === 401) {
      eraseCookie("BscAdminToken");
      message.warning("Sizin sessiyanız bitmişdir. Yenidən daxil olun.");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default $axios;
